import R from 'ramda';
import { TOGGLE_FILTER, SET_SELECTED_FILTERS, TOGGLE_FILTER_CATEGORY } from './actions';

const makeIsFilter = ({ categoryName, optionName }) => selectedFilter => (
  selectedFilter.categoryName === categoryName && selectedFilter.optionName === optionName
);

const toggleFilter = (state, { categoryName, optionName }) => {
  const selectedFilters = R.propOr([], 'selectedFilters')(state);
  const isFilter = makeIsFilter({ categoryName, optionName });
  const isNotFilter = selectedFilter => !isFilter({
    categoryName: selectedFilter.categoryName,
    optionName: selectedFilter.optionName,
  });
  const existingFilter = selectedFilters.find(isFilter);

  return existingFilter ? ({
    ...state,
    selectedFilters: selectedFilters.filter(isNotFilter),
  }) : ({
    ...state,
    selectedFilters: [...selectedFilters, { categoryName, optionName }],
  });
};

const setSelectedFilters = (state, { selectedFilters = [] }) => ({
  ...state,
  selectedFilters,
});

const toggleFilterCategory = (state, { categoryName }) => {
  const closedCategories = R.propOr({}, 'closedCategories')(state);

  return {
    ...state,
    closedCategories: {
      ...closedCategories,
      [categoryName]: !closedCategories[categoryName],
    },
  };
};

const reducer = {
  [TOGGLE_FILTER]: toggleFilter,
  [SET_SELECTED_FILTERS]: setSelectedFilters,
  [TOGGLE_FILTER_CATEGORY]: toggleFilterCategory,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
